// extracted by mini-css-extract-plugin
module.exports = {"header":"drawercab_header__1Hol0","image":"drawercab_image__QfCrh","name":"drawercab_name__2AV2M"};